// src/utils/composite.js
// Утилиты для работы с составными товарами (BOM).

// Проверяет является ли товар составным.
// Учитывает оба варианта структуры: полный (с include) и облегчённый (catalog).
export function isComposite(product) {
  if (!product) return false;
  const list = product.components;
  if (!Array.isArray(list)) return false;
  return list.length > 0;
}

// Считает максимальное число единиц составного товара,
// которое можно собрать из текущих остатков компонентов.
//
// products — массив всех товаров магазина (с их .stock)
// product  — составной товар, для которого считаем
//
// Возвращает целое число (округление вниз) или null если товар не составной
// или если у компонентов qty <= 0.
export function computeAvailable(product, products = []) {
  if (!isComposite(product)) return null;

  let minPossible = Infinity;

  for (const c of product.components) {
    const componentId = c.componentId || c.component?.id;
    const requiredPerUnit = Number(c.qty) || 0;
    if (!componentId || requiredPerUnit <= 0) continue;

    // Пытаемся взять stock из embedded component (catalog endpoint), иначе ищем в products
    let stock;
    if (c.component && c.component.stock != null) {
      stock = Number(c.component.stock);
    } else {
      const found = products.find(p => p.id === componentId);
      stock = found ? Number(found.stock) : 0;
    }

    // Если у компонента есть свои компоненты — это вложенный составной товар,
    // тогда его «доступность» — это computeAvailable рекурсивно.
    // Для простоты: если у компонента есть components, используем рекурсию,
    // иначе используем stock напрямую.
    let available;
    if (c.component && Array.isArray(c.component.components) && c.component.components.length > 0) {
      const nestedAvailable = computeAvailable(c.component, products);
      available = nestedAvailable != null ? nestedAvailable : 0;
    } else {
      available = isFinite(stock) ? stock : 0;
    }

    const perThis = Math.floor(available / requiredPerUnit);
    if (perThis < minPossible) minPossible = perThis;
  }

  return isFinite(minPossible) ? Math.max(0, minPossible) : 0;
}

// Возвращает обложку товара (главное фото) с поддержкой
// как нового формата (photos: string[]), так и старого (photo: string).
export function getMainPhoto(product) {
  if (!product) return null;
  if (Array.isArray(product.photos) && product.photos.length > 0) return product.photos[0];
  if (typeof product.photo === 'string' && product.photo) return product.photo;
  return null;
}
